import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { vitrinsTopOffersSlice } from './vitrinsTopOffers.slice';

type TVitrinsTopOffersState = SliceStateFromReducer<typeof vitrinsTopOffersSlice>;

export const vitrinsTopOffersSelector = (state: TVitrinsTopOffersState) => state.vitrinsTopOffers;

export const topOffersSelector = createSelector(vitrinsTopOffersSelector, (state) => state.topOffers);
